import { brandIdentifiers } from '../constants';

// Simple reducer as this is always set by the initial render
// but has scope to be customised in future.
export default (state = brandIdentifiers.default) => state;
